<template>
  <div>
    <el-row :gutter="10"
            v-if="user.accountType === null">
      <el-form :model="user"
               size="mini">
        <el-col :md="6">
          <el-form-item label="SELECCIONE TIPO DE USUARIO">
            <el-select v-model="user.accountType"
                       @change="accountTypeHandler"
                       placeholder="Seleccione una opción"
                       no-data-text="Cargando...">
              <el-option  v-for="type in accountTypes"
                          :key="type.id"
                          :label="type.type"
                          :value="{ id: type.id, type: type.type }"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <p v-else class="process-type">
      NUEVO: {{ user.accountType.type }}
    </p>
  </div>
</template>

<script>

export default {
  name: 'UserFormStep1',
  props: {
    accountTypes: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      user: { accountType: null },
    };
  },
  methods: {
    accountTypeHandler(accountType) {
      this.$emit('selected', accountType.id);
    },
  },
};
</script>

<style lang="scss" scoped>
  .process-type {
    font-size: 15px;
    font-weight: 900;
    text-transform: uppercase;
    color: $fb-green;
  }
</style>
